<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qwlqvo/tc-custom/9780061956775.jpg?1731166637876" alt="This image is the cover for the book Plainclothes Naked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plainclothes Naked
      </h1>
      <p class="bookDescription body article font2">
        <p>In a wildly careening plot that can only be described as <i>crack noir,</i> two pipeheads accidentally steal a photo of George W. Bush's presidential package and decide to blackmail the Republican Party. Before the crack-crazed thieves can follow through, however, gorgeous, whip-smart Nurse Tina, who's just offed her husband with a bowl of Drano-laced Lucky Charms, absconds with the goods. When Manny Rubert, a scarred ex-junkie turned codeine-popping detective, is called in to investigate the "foamer" hubby's untimely demise, love hits him like a wrench to the head. </p><p>Soon Manny and Tina are making plans of their own for the presidential pie -- and for their future together. But the meddling police chiefs and motel room sex-change surgeons of the world just won't leave them alone. And then there are those killer crackheads, still out there and closing in.... </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerry Stahl
      </h2>
      
      <p class="authorDescription body article">Jerry Stahl is the author of six books, including the memoir <i>Permanent Midnight</i> (made into a movie with Ben Stiller and Owen Wilson) and the novels <i>I, Fatty</i> and <i>Pain Killers</i>. Formerly the culture columnist for <i>Details</i>, Stahl's fiction and journalism have appeared in <i>Esquire</i>, the <i>New York Times</i>, and the <i>Believer</i>, among other places. He has worked extensively in film and television and, most recently, wrote <i>Hemingway &amp; Gellhorn</i>, starring Clive Owen and Nicole Kidman, for HBO.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?221efe86